import React, { useEffect, useState } from 'react';
import { IPublicClientApplication } from '@azure/msal-browser';
import { ActivityLogEntry } from '../../../types';
import { getProjectActivity, relativeTime } from '../../../services/activityService';

interface Props { pca: IPublicClientApplication; projectId: string; }

export default function ActivityTab({ pca, projectId }: Props) {
  const [items, setItems]     = useState<ActivityLogEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [top, setTop]         = useState(50);

  useEffect(() => {
    setLoading(true);
    getProjectActivity(pca, projectId, top).then(setItems).finally(() => setLoading(false));
  }, [pca, projectId, top]);

  return (
    <div style={{ padding: '24px 32px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h3>Activity</h3>
      </div>

      {loading && <div className="spinner" style={{ margin: '40px auto' }} />}
      {!loading && items.length === 0 && (
        <div className="card" style={{ padding: 48, textAlign: 'center', fontWeight: 300, fontSize: 15, color: 'var(--ink-3)' }}>
          No activity yet.
        </div>
      )}

      {!loading && items.length > 0 && items.map(a => {
        const actor = a.dagrun_pm_actorisai
          ? 'AI Agent'
          : (a.dagrun_pm_actorname ?? (a.dagrun_pm_actorid ? a.dagrun_pm_actorid.slice(0, 8) : 'System'));
        const detail = a.dagrun_pm_actiondescription ?? a.dagrun_pm_name;
        return (
          <div key={a.dagrun_pm_activitylogid} style={{
            borderLeft: '2px solid var(--brand-mist)',
            paddingLeft: 16, marginBottom: 16,
          }}>
            <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--ink-4)' }}>
              {relativeTime(a.createdon)}
            </div>
            <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink-2)', marginTop: 2 }}>
              {actor}
            </div>
            <div style={{ fontSize: 14, color: 'var(--ink)', fontWeight: 300, marginTop: 2 }}>
              {a.dagrun_pm_actiontype ?? 'Updated'}
              {a.dagrun_pm_entitytitle && (
                <> &rarr; <span style={{ fontWeight: 500 }}>{a.dagrun_pm_entitytitle}</span></>
              )}
              {detail && detail !== (a.dagrun_pm_actiontype ?? '') && (
                <span style={{ color: 'var(--ink-3)' }}> ({detail})</span>
              )}
            </div>
          </div>
        );
      })}

      {items.length >= top && (
        <button className="btn-secondary" style={{ marginTop: 12 }} onClick={() => setTop(top + 50)}>Load more</button>
      )}
    </div>
  );
}
